const topicItems = [
  { label: '#国漫崛起', heat: '超热', count: '586万讨论' },
  { label: '#日漫新番', heat: '热门', count: '423万讨论' },
  { label: '#韩漫推荐', heat: '热门', count: '318万讨论' },
  { label: '#漫画完结', heat: '超热', count: '291万讨论' },
  { label: '#修仙漫画', heat: '热门', count: '256万讨论' },
  { label: '#恋爱漫画', heat: '热门', count: '234万讨论' },
  { label: '#搞笑漫画', heat: '上升', count: '198万讨论' },
  { label: '#悬疑漫画', heat: '上升', count: '176万讨论' },
  { label: '#漫画改编', heat: '超热', count: '342万讨论' },
  { label: '#条漫推荐', heat: '上升', count: '152万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">漫画圈最火热的话题都在这里</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {topicItems.map((topic, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-4 hover:scale-[1.03] transition-transform cursor-pointer flex flex-col gap-2"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                    topic.heat === '超热'
                      ? 'bg-primary-100 text-primary-600'
                      : topic.heat === '热门'
                      ? 'bg-accent-100 text-accent-600'
                      : 'bg-secondary-100 text-secondary-600'
                  }`}
                >
                  {topic.heat}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-300 text-xs"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-800">{topic.label}</div>
              <div className="text-xs text-foreground-400">{topic.count}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}